import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon-loc.svg'
import _imports_1 from '@/assets/icon-zoom-in.svg'
import _imports_2 from '@/assets/icon-zoom-out.svg'


const _withScopeId = n => (_pushScopeId("data-v-5772e6b1"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "jr-m-auto",
  src: _imports_0,
  alt: "location"
}, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "jr-rounded-lg jr-bg-white" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "jr-m-auto",
  src: _imports_1,
  alt: "zoom in"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "jr-w-3/4 jr-m-auto jr-border-gray-light" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "jr-m-auto",
  src: _imports_2,
  alt: "zoom out"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GoogleMap = _resolveComponent("GoogleMap")!

  return (_openBlock(), _createBlock(_component_GoogleMap, {
    id: "google-map",
    ref: "gMap",
    language: "ja",
    region: "JP",
    libraries: ['visualization', 'places', 'drawing'],
    "api-key": _ctx.apiKey,
    center: _ctx.center,
    disableDefaultUi: true,
    draggable: true,
    clickableIcons: false,
    styles: _ctx.mapStyle,
    tilt: 0,
    heading: 0,
    zoom: _ctx.defaultZoom,
    maxZoom: _ctx.maxZoom,
    onDragend: _ctx.onChangeMapPosition,
    onIdle: _ctx.onLoad
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "transition jr-absolute jr-bottom-3 jr-z-10",
        style: _normalizeStyle({ right: `${_ctx.right}px` })
      }, [
        _createElementVNode("button", {
          class: "jr-block jr-w-7.5 jr-h-7.5 jr-bg-white jr-rounded-lg jr-mb-2.5",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleCurrentLocation && _ctx.handleCurrentLocation(...args)))
        }, _hoisted_2),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "jr-block jr-w-7.5 jr-h-7.5 jr-bg-white jr-rounded-t-lg",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleZoomIn && _ctx.handleZoomIn(...args)))
          }, _hoisted_5),
          _hoisted_6,
          _createElementVNode("button", {
            class: "jr-block jr-w-7.5 jr-h-7.5 jr-bg-white jr-rounded-b-lg",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleZoomOut && _ctx.handleZoomOut(...args)))
          }, _hoisted_8)
        ])
      ], 4),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _: 3
  }, 8, ["api-key", "center", "styles", "zoom", "maxZoom", "onDragend", "onIdle"]))
}